module.exports = __webpack_public_path__ + "static/media/Rozet.a9f23ae8.svg";